module.exports = __webpack_public_path__ + "images/emoji/scream.5d17b360cd226efffedf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/scream.png
// module id = zR24
// module chunks = 2